module.exports = __webpack_public_path__ + "static/media/register.cdcaf2b8.pdf";